"use client";

import React from 'react';
import { Bar } from '@visx/shape';
import { Group } from '@visx/group';
import { AxisBottom, AxisLeft } from '@visx/axis';
import { scaleBand, scaleLinear } from '@visx/scale';
import { Card, CardHeader, CardTitle, CardContent } from '../Components/Ui/Card'; // تأكد من المسار الصحيح

const HorizontalBarChart = () => {
  const data = [
    { label: 'Email', value: 100 },
    { label: 'YouTube', value: 70 },
    { label: 'Maps', value: 50 },
    { label: 'Ads', value: 30 },
    { label: 'Felsir', value: 10 },
    { label: 'Search', value: 90 },
  ];

  const width = 500;
  const height = 200; // قللنا الارتفاع
  const margin = { top: 20, right: 20, bottom: 50, left: 80 };

  const xMax = width - margin.left - margin.right;
  const yMax = height - margin.top - margin.bottom;

  const xScale = scaleLinear({
    range: [0, xMax],
    domain: [0, Math.max(...data.map(d => d.value))],
  });

  const yScale = scaleBand({
    range: [0, yMax],
    domain: data.map(d => d.label),
    padding: 0.3
  });

  // تحديد الألوان بشكل ديناميكي
  const getColor = (label) => {
    switch(label) {
      case 'Email': return '#95a4fc'; // لون مخصص لـ Email
      case 'YouTube': return '#baedbd'; // لون مخصص لـ YouTube
      case 'Maps': return '#1c1c1c'; // لون مخصص لـ Maps
      case 'Ads': return '#b1e3ff'; // لون مخصص لـ Ads
      case 'Felsir': return '#a8c5da'; // لون مخصص لـ Felsir
      case 'Search': return '#a1e3cb'; // لون مخصص لـ Search
      default: return '#7748F8'; // اللون الافتراضي
    }
  };

  return (
    <Card className="w-full bg-transparent">
      <CardHeader>
        <CardTitle>Registration movement</CardTitle>
      </CardHeader>
      <CardContent>
        <svg width={width} height={height} style={{ background: 'none' }}>
          <Group top={margin.top} left={margin.left}>
            {data.map((d) => {
              const barHeight = yScale.bandwidth();
              const barWidth = xScale(d.value);
              const barY = yScale(d.label);

              return (
                <Group key={`bar-${d.label}`}>
                  <Bar
                    x={0}
                    y={barY}
                    width={barWidth}
                    height={barHeight}
                    fill={getColor(d.label)}  // تعيين اللون لكل عمود بناءً على الـ label
                    rx={10}
                  />
                  <text
                    x={barWidth + 5}
                    y={barY + barHeight / 2}
                    dy=".35em"
                    fontSize={12}
                    fill="#444"
                  >
                    {d.value}K
                  </text>
                </Group>
              );
            })}

            <AxisLeft
              scale={yScale}
              stroke="#888"
              tickStroke="#888"
              tickLabelProps={() => ({
                fill: '#666',
                fontSize: 12,
                textAnchor: 'end',
                dy: '0.33em',
              })}
            />

            <AxisBottom
              top={yMax}
              scale={xScale}
              stroke="#888"
              tickStroke="#888"
              tickLabelProps={() => ({
                fill: '#666',
                fontSize: 12,
                textAnchor: 'middle',
              })}
            />
          </Group>
        </svg>
      </CardContent>
    </Card>
  );
};

export default HorizontalBarChart;
